import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../@casino/ui/table';
import Title from '../../../../../@casino/ui/title';
import { setGetDailyList } from '../../store/thunk/setGetDailyList';
import {getRows, columns} from './helper';
import {useFormik, FormikContext} from "formik";
import Switch from '@material-ui/core/Switch';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    root: {
        width: 'calc(100% - 40px)',     
        background: '#1b2039',
        borderRadius: '8px',
        padding: 20,
        marginTop: 12,
        marginBottom: 20
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        borderRadius: 4,
        color: '#fff',
        outline: 'none',
        margin: '10px 0',
        width: '97.3%'
    },
    colorFFF: {
        color: '#fff',
    },
    divider: {
        height: 1, background: 'rgb(176, 176, 176)', marginTop: 12
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', alignItems: 'center', width: 165, color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
    text: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff',
        height: 36,
        width: 149
    },
}));
const ReportDaily = () => {
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetDailyList({
            search: '',
            page: 1,
            rowsPerPage: 25,
            date_from: 0,
            date_to: new Date().getTime()
        }));
    }, [])

    const initialValues = {
        search: '',
        check: false,
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});
    
    const daily = useSelector(state => state.daily.list);
    const rows = getRows(daily.list);

    return (
        <div style={{padding: 20, paddingTop: 0, overflowY: 'scroll', height: '100%'}}>
            <Title label="Финансовые операции"/>
            <FormikContext.Provider value={formik}>
                <form style={{
                    padding: '0 20px',
                    background: '#1b2039', 
                    borderRadius: 8, 
                    marginBottom: 12,
                    width: 'calc(100% - 40px)',
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <div style={{display: 'flex', marginRight: 12}}>
                            <label htmlFor="check" className={classes.wrapSwitch}>
                                <span className={classes.manually}>Ручн. время</span>
                                <Switch
                                    checked={formik.values.check}
                                    onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </label>
                            <span className={classes.spo}>С</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                className={classes.datetime}
                                value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(0);
                                        date.setMinutes(0);
                                        date.setSeconds(0);
                                        date.setMilliseconds(0);
                                    }
                                   
                                    formik.setFieldValue('date_from', date.getTime());

                                    dispatch(setGetDailyList({
                                        search: formik.values.search,
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                        page: 1,
                                        rowsPerPage: 25,
                                    }))
                                }}
                            />
                            <span className={classes.spo}>ПО</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(23);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        date.setMilliseconds(999);
                                    }

                                    formik.setFieldValue('date_to', date.getTime());
                                    dispatch(setGetDailyList({
                                        search: formik.values.search,
                                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                                        date_to: isNaN(date.getTime()) ? new Date().getTime() : date.getTime(),
                                        page: 1,
                                        rowsPerPage: 25,
                                    }))
                                    
                                }}
                            />
                        </div>
                    </div>
                    <input 
                        type="text"
                        placeholder="Поиск"
                        className={classes.search}
                        value={formik.values.search}
                        onChange={(v) => {
                            formik.setFieldValue('search', v.target.value)
                            dispatch(setGetDailyList({
                                search: v.target.value,
                                date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                                date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                page: 1,
                                rowsPerPage: 25,
                            }))
                        }}
                    />
                </form>
            </FormikContext.Provider>
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
                
            }}>
                <TableCasino
                    pagination
                    allPage={daily.count}
                    width={1300}
                    perPage={25}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetDailyList({
                        search: formik.values.search,
                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                   
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetDailyList({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        search: formik.values.search
                    }))}
                /> 
            </div>
        </div>
    )
}

export default ReportDaily;